import { computed, getCurrentInstance, ref } from '@vue/composition-api';
import ContentStackApi from '@api/ContentStack';

export const usePaymentVerbiage = () => {
  const vm = getCurrentInstance();
  
  const add_payment_method_disclaimer_html = ref('');
  const add_user_payment_subgroup_required = ref('');
  const debited_date_notice_html = ref('');
  const disabled_recurring_payment_content_html = ref('');
  const disabled_recurring_payment_title = ref('');
  const enable_recurring_payment_disclaimer_html = ref('');
  const expired_payment_method = ref('');
  const expiring_payment_method = ref('');
  const recurring_payment_setup_prompt_html = ref('');
  const recurring_payments_enabled_html = ref('');
  const recurring_payment_day_of_month = ref('');
  const max_user_payment_limit = ref(5);
  const maximum_user_payment_help_text = ref('');
  const multiple_lob_help_text = ref('');
  const no_payment_method_content_html = ref('');
  const no_payment_method_title = ref('');
  const payment_history_header = ref('');
  const self_bill_help = ref('');
  
  const initPaymentVerbiage = () => {
    new ContentStackApi().getContentStackContent({
      cloudCannonResource: '/payment-verbiage.json'
    })
    .then(response => {
      debited_date_notice_html.value = response.debited_date_notice_html;
      recurring_payment_setup_prompt_html.value = response.recurring_payment_setup_prompt_html;
      recurring_payments_enabled_html.value = response.recurring_payments_enabled_html;
      recurring_payment_day_of_month.value = response.recurring_payment_day_of_month;
      no_payment_method_title.value = response.no_payment_method_title;
      no_payment_method_content_html.value = response.no_payment_method_content_html;
      disabled_recurring_payment_title.value = response.disabled_recurring_payment_title;
      disabled_recurring_payment_content_html.value = response.disabled_recurring_payment_content_html;
      add_payment_method_disclaimer_html.value = response.add_payment_method_disclaimer_html;
      enable_recurring_payment_disclaimer_html.value = response.enable_recurring_payment_disclaimer_html;
      self_bill_help.value = response.self_bill_help;
      expired_payment_method.value = response.expired_payment_method;
      expiring_payment_method.value = response.expiring_payment_method;
      add_user_payment_subgroup_required.value = response.add_user_payment_subgroup_required;
      maximum_user_payment_help_text.value = response.maximum_user_payment_help_text;
      payment_history_header.value = response.payment_history_header;
      multiple_lob_help_text.value = response.multiple_lob_help_text;
      if (response.max_user_payment_limit) {
        max_user_payment_limit.value = response.max_user_payment_limit;
      }
    })
    .catch(err => {
      console.warn(err.message);
    })
  }

  return {
    add_payment_method_disclaimer_html,
    add_user_payment_subgroup_required,
    debited_date_notice_html,
    disabled_recurring_payment_content_html,
    disabled_recurring_payment_title,
    enable_recurring_payment_disclaimer_html,
    expired_payment_method,
    expiring_payment_method,
    initPaymentVerbiage,
    recurring_payment_setup_prompt_html,
    recurring_payments_enabled_html,
    recurring_payment_day_of_month,
    max_user_payment_limit,
    maximum_user_payment_help_text,
    multiple_lob_help_text,
    no_payment_method_content_html,
    no_payment_method_title,
    payment_history_header,
    self_bill_help,
  }
}